<template>
    <div class="userInfoUpper wrapper" v-if="$mq=='lg'">
        <div class="left">
            {{'components/user-info-upper.title' | trans}} <span class="name">{{ user.name }}</span>
            <span class="slash"></span>
			{{'components/user-info-upper.account' | trans}} {{ user.loan }}
        </div>
        <div class="right">
            <img src="/assets/img/pin.svg" alt="pin">
            {{ user.location }}
        </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    export default {
        computed : {
            ...mapState(['user'])
        }
    }
</script>
